'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getArrowMarkerId = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lineUtil = require('../lineUtil');

var _lineUiConstants = require('../lineUiConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var START_ARROW_MARKER_PATH = 'M' + _lineUiConstants.ARROW_WIDTH_UNITS + ',0 L0,' + _lineUiConstants.ARROW_HEIGHT_UNITS / 2 + ' L' + _lineUiConstants.ARROW_WIDTH_UNITS + ',' + _lineUiConstants.ARROW_HEIGHT_UNITS + ' z';

// Constants
// Lib

var END_ARROW_MARKER_PATH = 'M0,0 L' + _lineUiConstants.ARROW_WIDTH_UNITS + ',' + _lineUiConstants.ARROW_HEIGHT_UNITS / 2 + ' L0,' + _lineUiConstants.ARROW_HEIGHT_UNITS + ' z';

var getArrowMarkerId = exports.getArrowMarkerId = function getArrowMarkerId(_ref) {
    var edge = _ref.edge,
        elementId = _ref.elementId,
        idSuffix = _ref.idSuffix;
    return (0, _lodash.compact)(['arrow', edge, elementId, idSuffix]).join('-');
};

var ArrowMarker = function ArrowMarker(_ref2) {
    var edge = _ref2.edge,
        elementId = _ref2.elementId,
        idSuffix = _ref2.idSuffix,
        colorHex = _ref2.colorHex;

    var path = (0, _lineUtil.isStartEdge)(edge) ? START_ARROW_MARKER_PATH : END_ARROW_MARKER_PATH;
    var refX = (0, _lineUtil.isStartEdge)(edge) ? 1 : _lineUiConstants.ARROW_WIDTH_UNITS - 1;

    return _react2.default.createElement(
        'marker',
        { id: getArrowMarkerId({ edge: edge, elementId: elementId, idSuffix: idSuffix }), className: 'arrow',
            viewBox: '0 0 ' + _lineUiConstants.ARROW_WIDTH_UNITS + ' ' + _lineUiConstants.ARROW_HEIGHT_UNITS,
            refX: refX, refY: _lineUiConstants.ARROW_HEIGHT_UNITS / 2,
            markerWidth: _lineUiConstants.ARROW_WIDTH_UNITS, markerHeight: _lineUiConstants.ARROW_HEIGHT_UNITS,
            orient: 'auto', markerUnits: 'strokeWidth', fill: colorHex },
        _react2.default.createElement('path', { d: path })
    );
};

ArrowMarker.propTypes = {
    edge: _propTypes2.default.string.isRequired,
    elementId: _propTypes2.default.string.isRequired,
    idSuffix: _propTypes2.default.string,
    colorHex: _propTypes2.default.string
};

exports.default = ArrowMarker;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/svg/ArrowMarker.js
// module id = 1995
// module chunks = 0